import React from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { getLanguage } from 'store/language/selectors';
import strings from 'lib/strings';

const Strings = ({ language, label, html = false }) => {
  strings.setLanguage(language);

  return (
    html
      ? <div dangerouslySetInnerHTML={{ __html: strings[label] }} />
      : strings[label]
  );
};

const mapStateToProps = createSelector(
  getLanguage,
  language => ({ language })
);

export default connect(mapStateToProps)(Strings);



// WEBPACK FOOTER //
// ./src/components/Strings/index.js